import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import useHistoryPush from '../../hooks/useHistoryPush';
import useCommonToast from '../../hooks/useCommonToast';
import DefinitionsSkeleton from '../utils/DefinitionsSkeleton';
import mappedItemTypes from 'services/items/mappedItemTypes';
import useItemCreationWizard from 'hooks/useItemCreationWizard';
import { THIRTY_SECOND_DURATION_IN_MILLISECONDS } from 'constants/time';

const MoveToItemPageStep = () => {
    const historyPush = useHistoryPush();
    const { toast } = useCommonToast();
    const [toastSent, setToastSent] = useState(false);
    const intl = useIntl();

    const {
        itemTypeId: selectedItemTypeId,
        itemTypeName,
        newItemId,
        formDataForItemCreation: itemFormData,
        resetWizard,
        genericTimeoutHit,
    } = useItemCreationWizard();

    useEffect(() => {
        if (!toastSent) {
            const status = selectedItemTypeId == null || selectedItemTypeId > 0 ? 'success' : 'info';
            const message =
                selectedItemTypeId != null
                    ? selectedItemTypeId > 0
                        ? intl.formatMessage({ id: 'common_item_creation_success' }, { type: itemTypeName })
                        : intl.formatMessage({ id: 'item_creation_wizard_cancellation' })
                    : intl.formatMessage({ id: 'common_delete_success' }, { item: itemFormData.description });

            //display appropriate toast message, which may display duplicate messages due to StrictMode
            if (genericTimeoutHit) {
                const apiDidNotFinishMessage = intl.formatMessage({ id: 'generic_asset_item_created_message' });
                toast({
                    status: 'info',
                    message: apiDidNotFinishMessage,
                    duration: THIRTY_SECOND_DURATION_IN_MILLISECONDS,
                });
            } else {
                toast({
                    status: status,
                    message: message,
                });
            }
            setToastSent(true);
        }
        switch (selectedItemTypeId) {
            case mappedItemTypes.BATTERY_STORAGE.id:
                historyPush(`/batteries/${newItemId}`);
                break;
            case mappedItemTypes.GENERATION_ASSET.id:
                historyPush('/thermal');
                break;
            case mappedItemTypes.WIND_ASSET.id:
                historyPush(`/renewables/${newItemId}`);
                break;
            case -1:
                historyPush('/');
                break;
            case null:
            default:
                historyPush('/');
                break;
        }
        setTimeout(() => {
            resetWizard();
        }, 1000);
    }, [
        historyPush,
        toast,
        intl,
        selectedItemTypeId,
        itemTypeName,
        itemFormData,
        newItemId,
        resetWizard,
        genericTimeoutHit,
        toastSent,
    ]);

    return <DefinitionsSkeleton />;
};

export default MoveToItemPageStep;
